import { FC } from 'react';
import { Link } from 'react-router-dom';

import { ExtendedTableColumn, FlexGroup, FlexItem, Table } from '@lithos';
import NoData from './NoData';

interface HealthResult {
  feature_package_id: string;
  feature_view_name: string;
  workspace_name: string;
}

interface FeatureViewIdsTableProps {
  healthResults: HealthResult[];
}

const FeatureViewHealthTable: FC<FeatureViewIdsTableProps> = ({ healthResults }) => {
  // empty state
  if (healthResults.length === 0) {
    return (
      <div>
        <NoData />
      </div>
    );
  }

  const columns: ExtendedTableColumn<HealthResult & { id: string }>[] = [
    {
      name: `Feature View`,
      id: 'name',
      content: (item: HealthResult) => (
        <>
          <Link to={`/repo/${item.workspace_name}/features/${item.feature_view_name}`} title={item.feature_view_name}>
            {item.feature_view_name}
          </Link>
        </>
      ),
    },
  ];

  return (
    <>
      <FlexGroup>
        <FlexItem>
          <Table
            columns={columns}
            compressed
            items={healthResults.map((item) => ({ ...item, id: item.feature_view_name }))}
          />
        </FlexItem>
      </FlexGroup>
    </>
  );
};

export default FeatureViewHealthTable;
